import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ReservationTicketComponent } from "src/app/shared/product/components/reservation-ticket/reservation-ticket.component";
import { BaseForm } from '../../../../../../../shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
@Component({
  selector: 'app-reservation-step-two',
  templateUrl: './reservation-step-two.component.html',
  styleUrls: ['./reservation-step-two.component.scss']
})
export class ReservationStepTwoComponent extends BaseForm implements OnInit {
  @Input() searchableSelectDefaultValue: any;
  formValidator: FormValidatorService = new FormValidatorService();
  stepForm!: FormGroup;
  EventDurationError: string = '';
  isUpdate: any;
  @ViewChild(ReservationTicketComponent) tickets!: ReservationTicketComponent;
  productTypeId: any;

  controllers: any = {
    image: {
      fieldName: "Reservation Image",
      fieldNameAr: "صورة الفعالية",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    Return_terms: {
      fieldName: "Return terms",
      fieldNameAr: "شروط الاسترجاع",
      fieldType: "Return terms",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
    Delivery_terms: {
      fieldName: "Delivery terms",
      fieldNameAr: "شروط التوصيل",
      fieldType: "Delivery terms",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
    is_buyer_info: {
      fieldName: "Do you want to Add extra Buyer info fields to your product?",
      fieldNameAr: "هل تريد ان تأخذ معلومات اضافية من المشتري؟",
      fieldType: "Do you want to Add extra Buyer info fields to your product?",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
    Ticket: {
      fieldName: "Ticket",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
      ],
    },

  };

  constructor() {
    super();
  }

  ngOnInit() {
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );
    //console.log('stepForm', this.stepForm.value);
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }

}
